<mbs-modal [title]="'shared:computers.modals.backupAgentUpdateRequiredToUseConnectTitle' | i18next">
  <ng-container modal-body>
    <mbs-alert
      [type]="alertType"
      [icon]="true">
      {{ 'shared:computers.modals.backupAgentUpdateRequiredToUseConnectAlertText' | i18next: { computerName, version: version } }}
      <a
        target="_blank"
        [helpLink]="'https://kb.msp360.com/kb10140'"
        [kbMode]="true">
        {{ 'shared:buttons.learnMore' | i18next }}
      </a>
    </mbs-alert>
    {{ 'shared:computers.modals.backupAgentUpdateRequiredToUseConnectText' | i18next: { computerName } }}
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      [type]="'secondary'"
      (click)="baseModal.close()">
      {{ 'shared:buttons.close' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
